export default __webpack_public_path__ + "static/media/3447.ee2247ef.png";